import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;

  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #d4d9e2;
  border-radius: 0.75rem;

  background: transparent;
  color: #c2cad6;

  transition: 0.2s ease-in-out;

  & + div {
    margin-top: 1rem;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: #1d62d1;

      color: #1d62d1;
    `}

  ${props =>
    props.isFilled &&
    css`
      color: #1d62d1;
    `}

  input {
    width: 100%;

    border: 0;

    background: transparent;

    &::placeholder {
      color: #c2cad6;
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  & > div:first-child {
    margin-right: 0.75rem;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
